import { Box, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { FullDate } from '../../../../components/Date/FullDate'
import { CustomBtn } from '../../../../components/button/button'
import { Input } from '../../../../components/input/input'
import { Main } from '../../../../constant'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import dayjs from 'dayjs'
import CustomTable from '../../../../components/table/SimpleTable'
import { ShowLoader } from '../../../../redux/actions/loader'

function StopTransport(studentDetails) {
    // //console.log(studentDetails)
    const [data, setData] = useState(Main().Fee);
    const [getfilterdata, setGetfilterdata] = useState(data.inputs.filter((item) => item.feildtype !== 'label'));
    const [initialInputValues, setInitialInputValues] = useState(Object.fromEntries(
      getfilterdata
        .map((item) => [item.name, ''])
    ));
    const [inputValues, setInputValues] = useState({ Date: dayjs().format('MMMM YYYY'), ...initialInputValues });
    const [amount, setAmount] = useState('');
    const [feesPay, setFeesPay] = useState('');
    const [currentPayment, setCurrentPayment] = useState(0);
    
  const dispatch = useDispatch();
  const userToken = JSON.parse(sessionStorage.getItem('User_Data'))?.token || undefined;
  const url = useSelector((state) => state.Api);
  const [studentOldDetails, setStudentOldDetails] = useState()
  const [feesForMonth, setFeesFormMonth] = useState(0);
  const [numberOfDays, setNumberOfDays] = useState(0);
  const [feesForNumberOfDays, setFeesForNumberOfDays] = useState(0);
  const showlatefee = useSelector((state) => state.Api.showlatefee);
  const [dues, setDues] = useState(studentDetails?.studentDetails?.status?.dues - studentDetails?.studentDetails?.status?.paid);
  const [stopDate, setStopDate] = useState();
  const [balanceTobePaid, setBalanceTobePaid] = useState();
      
  const calculateFees = () => {
    const timestamp = window.Date.now(); // You can also just use Date.now()
    const currentDate = dayjs(timestamp); // Use dayjs to get the current date
    let feesForDays = 0;
    const daysInCurrentMonth = currentDate.daysInMonth();

    if (inputValues.DateFrom) { // Check if DateFrom is falsy (undefined or empty)
      const startDate = parseInt(inputValues.DateFrom.split('-')[2], 10);
      const remainingDays = daysInCurrentMonth - (startDate - 1);
      feesForDays = (amount / daysInCurrentMonth) * remainingDays;
      setNumberOfDays(remainingDays);
    } else {
      const remainingDays = daysInCurrentMonth - currentDate.date();
      feesForDays = (amount / daysInCurrentMonth) * remainingDays;
      // If you need to set the number of days for the current date, uncomment the line below
      setNumberOfDays(remainingDays);
    }

    // Ensure you're only setting state when necessary to avoid loops
    setFeesForNumberOfDays(feesForDays.toFixed(2));
    setFeesFormMonth(currentDate.month() + 1);

  }

  useEffect(() => {
    calculateFees()
  }, [amount, inputValues, dues, feesPay])

  const ChangeDate = (e) => {
    // //console.log(`${e.$y}-${e.$M}-${e.$D}`)
    //console.log(`${e.$y}-${e.$M + 1}-${e.$D}`)
    setInputValues((prevValues) => ({
      ...prevValues,
      DateFrom: `${e.$y}-${e.$M + 1}-${e.$D}`,
    }));
    calculateFees()
  }
  const StopDate = (e) => {
    // //console.log(`${e.$y}-${e.$M}-${e.$D}`)
    //console.log(`${e.$y}-${e.$M + 1}-${e.$D}`)
    setStopDate(`${e.$y}-${e.$M + 1}-${e.$D}`)
    setInputValues((prevValues) => ({
      ...prevValues,
      DateEnd: `${e.$y}-${e.$M + 1}-${e.$D}`,
    }));
    remainingFees(`${e.$y}-${e.$M + 1}-${e.$D}`)
  }

  const remainingFees = (getEndDate) => {
    // e.preventDefault()
    const timestamp = window.Date.now(); // You can also just use Date.now()
    const currentDate = dayjs(timestamp); // Use dayjs to get the current date
    let balanceTobePay = 0;
    const daysInCurrentMonth = currentDate.daysInMonth();
    // const remainingDays = daysInCurrentMonth - currentDate.date();
    const lastDate = parseInt(getEndDate?.split('-')[2]);
    //console.log(getEndDate?.split('-'))

    balanceTobePay = (studentDetails?.studentDetails?.status?.ActualFees / daysInCurrentMonth) * lastDate;
    //console.log(studentDetails?.studentDetails?.status?.ActualFees, daysInCurrentMonth, lastDate)
    setBalanceTobePaid(balanceTobePay.toFixed(2))
  }

  const getCurrePayment = (event) => {
    event.preventDefault();
    setCurrentPayment(event.target.value)
  }

  function removeStudent(e) {
    e.preventDefault();
    const payload = {
      EndDate: stopDate,
      FeesTypeSrn: studentDetails?.studentDetails?.status?.FeesTypeSrn,
      RollNum: studentDetails?.studentDetails?.StudentDetails?.RollNum,
      CurrentPayment: currentPayment,
      CurrentBalance: balanceTobePaid,
      UnpaidBalance: (balanceTobePaid + dues) - currentPayment,
      Month: parseInt(stopDate?.split('-')[1])
    }
    //console.log(payload)
    // remainingFees()
    // return false 
    try {
      dispatch(ShowLoader('1'))
      axios.post(url.transportStopService, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userToken}`,
        },
      })
        .then((res) => {
          if (res.status === 200) {
          dispatch(ShowLoader('0')) 
            // //console.log(res.data.result);
          }
        })
        .catch((err) => {
          dispatch(ShowLoader('0')) 
          //console.error(err); // Log the error response for debugging
        });
    } catch (err) {
      dispatch(ShowLoader('0')) 
      //console.error(err);
    }
  }
    return (
        <>
            {studentDetails?.studentDetails?.status?.TransportFacility == 'No'?
            <Grid>Please Enroll In Transport {studentDetails?.studentDetails?.StudentDetails?.Name_P}</Grid>  
          :
          <form onSubmit={removeStudent}>
                    <Grid>
                      <FullDate throwfullevent={StopDate} name='endDate' />

                      <Typography sx={{ color: 'blue' }} variant='b'>
                        Current Month Fees: {studentDetails?.studentDetails?.status?.ActualFees}
                      </Typography>
                      <br />
                      <Typography sx={{ color: 'red' }} variant='b'>
                        Dues: {dues}
                      </Typography>
                      <br />
                      <Typography sx={{ color: 'red' }} variant='b'>
                        Balance : {balanceTobePaid} ({stopDate})
                      </Typography>
                      <br />
                      <Typography sx={{ color: 'red' }} variant='b'>
                        Total Balance : {(parseFloat(balanceTobePaid) + parseFloat(dues)).toFixed(2)}
                      </Typography>
                      <br />
                      <Input sx={{ margin: '0px 0px 0px' }} value={currentPayment} onChange={(event) => getCurrePayment(event)} name="Amount" placeholder='Fees' />

                      <Typography sx={{ color: 'red' }} variant='b'>
                        Remaining Balance : {((parseFloat(balanceTobePaid) + parseFloat(dues)) - parseFloat(currentPayment)).toFixed(2)}
                      </Typography>
                      <br />
                      <Typography sx={{ color: 'red' }} variant='b'>
                        <CustomBtn disabled={true} data='Stop Transport' />
                      </Typography>
                      <br />
                    </Grid>
                  </form>
          }


          
          <br/>
          <br/>
        <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', width:'117%' }}>
        {
                                studentDetails?.studentDetails && studentDetails?.studentDetails?.result?.length != 0 && studentDetails?.studentDetails?.result != null && studentDetails?.studentDetails?.result != undefined  ?
                                <CustomTable data={studentDetails?.studentDetails?.result} />            
                                :
                                null
                            }
                  </Box>
        </>
    )
}

export default StopTransport
